import React from "react";

import { useDispatch, useSelector } from "react-redux";

import './Login.css';
import { changeFailed, changeFormPassword, changeFormUserId, failedLogin, isLoggedIn, isLoggingIn, login, selectFormPassword, selectFormUserId, selectLoginError } from "./loginSlice";
import { Navigate } from "react-router-dom";
import { changeUsername } from "../home/userSlice";

export default function Login() {
    const dispatch = useDispatch();

    const formUserId = useSelector(selectFormUserId);
    const formPassword = useSelector(selectFormPassword);
    const loggedIn = useSelector(isLoggedIn);
    const loggingIn = useSelector(isLoggingIn);
    const failed = useSelector(failedLogin);
    const errorMessage = useSelector(selectLoginError);

    const handleUserIdChange = (event) => {
        const newUserId = event.target.value;
        dispatch(changeFormUserId(newUserId));
    }

    const handlePasswordChange = (event) => {
        const newPassword = event.target.value;
        dispatch(changeFormPassword(newPassword));
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        if (formUserId && formPassword) {
            dispatch(changeUsername(formUserId));
            dispatch(login({username: formUserId, password: formPassword}));
        } else {
            dispatch(changeFailed(true));
        }
    }

    if (loggedIn) {
        return <Navigate replace to={"/home"} />;
    } else {
        return (
            <main>
                <section className="login">
                    <h2>Welcome Back!</h2>
                    <h3>Please login to your account to continue.</h3>
                    <form onSubmit={handleSubmit}>
                        <label htmlFor="userId">
                            User Id:
                            <input name="userId" onChange={handleUserIdChange} value={formUserId}></input>
                        </label>
                        <label htmlFor="password">
                            Password:
                            <input name="password" type="password" onChange={handlePasswordChange} value={formPassword}></input>
                        </label>
                        {failed ? <p className="error">{errorMessage}</p>: ""}
                        <button type="submit" disabled={loggingIn}>{loggingIn ? "Logging In..." : "Log in"}</button>
                    </form>
                </section>
            </main>
        )
    }
}